import { render, staticRenderFns } from "./ImageFile.vue?vue&type=template&id=ab2f699c&scoped=true"
import script from "./ImageFile.vue?vue&type=script&lang=js"
export * from "./ImageFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2f699c",
  null
  
)

export default component.exports